const initialState = {
    fav_search: null,
    fav_resort: null,
    fav_failure: false,
}
export default function FavoritesReducer(state = initialState, action) {
    switch (action.type) {
        case "update_search_Data":
            return {
                ...state,
                fav_search: action.data
            }
        case 'fav_resort_failure':
            return {
                ...state,
                fav_failure: action.data,
            };
        case "update_resort_Data":
            return {
                ...state,
                fav_resort: action.data
            }
        case "modify_search_Data":
            let modifyList = [...state.fav_search];
            for (let i = 0; i < modifyList.length; i++) {
                if (modifyList[i].requestId == action.data.requestId) {
                    modifyList[i].activeFlag = action.data.activeFlag;
                    break;
                }
            }
            return {
                ...state,
                fav_search: modifyList
            }
        case "modify_resort_Data":
            let modifyrstList = [...state.fav_resort];
            for (let i = 0; i < modifyrstList.length; i++) {
                if (modifyrstList[i] !== null) {
                    if (modifyrstList[i].resortID === action.data.resortID) {
                        modifyrstList[i].activeFlag = action.data.activeFlag;
                        break;
                    }
                }
            }
            return {
                ...state,
                fav_resort: modifyrstList
            }
        default:
            return {
                ...state
            }
    }

}

